import { doc, getDoc } from 'firebase/firestore';
import { useState } from 'react';
import { useEffect } from 'react';
import './App.css';
import { db } from './config/firebase';

function App() {

  const [ratingsData, setRatingsData] = useState([])
  const routes = ['NCAAB', 'NCAAF', 'NHL']

  useEffect(() => {
    const resolve = async () => {
      const dbRef = doc(db, "oddsData", "sagarinRatingsData")
      return (await getDoc(dbRef)).data()
    }
    resolve()
    .then((data) => {
      if(routes.includes(window.location.pathname?.split('/')[1])) {
        setRatingsData(data?.[window.location.pathname.split('/')[1]])
      }
    })
    // eslint-disable-next-line
  }, [])

  return (
    <figure className="app">
      <table>
        <tbody>
          <tr>
            <td className='text-center'>
              <strong>Rank</strong>
            </td>
            <td>
              <strong>Team</strong>
            </td>
            <td className='text-center'>
              <strong>Rating</strong>
            </td>
          </tr>
          {ratingsData.map(({ rank, team, rating }) => (
             <tr className='data-row'>
              <td className='text-center'>
                <strong>{rank}</strong>
              </td>
              <td>
                <strong>{team}</strong>
              </td>
              <td className='text-center'>
                <strong>{rating}</strong>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </figure>
  );
}

export default App;
